import { render } from "./LColorSuggested.vue?vue&type=template&id=4a78030f&scoped=true&ts=true"
import script from "./LColorSuggested.vue?vue&type=script&lang=ts"
export * from "./LColorSuggested.vue?vue&type=script&lang=ts"

import "./LColorSuggested.vue?vue&type=style&index=0&id=4a78030f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a78030f"]])

export default __exports__